import http from "@/http-common";

class ShopService {
  loadShop(id, params) {
    return http.get(`/shop/${id}`, { params });
  }

  search(query) {
    return http.get("/shop/search", {
      params: {
        q: query,
      },
    });
  }

  /*
   * Following Shops
   */
  getFollowedShops() {
    return http.get("/user/shop", {
      params: {
        limit: 300,
        offset: 0,
      },
    });
  }

  followShops(ids) {
    return http.post("/user/shop", { shopIds: ids });
  }

  followShop(id) {
    return http.post("/user/shop", { shopIds: [id] });
  }

  unfollowShop(id) {
    return http.delete(`/user/shop/${id}`);
  }

  /*
   * Spotify Shops
   */
  getSpotifyShops() {
    return http.get("/shop/artists");
  }

  /*
   * Popular Shops
   */
  getPopularShops(params) {
    return http.get("/shop/top", { params });
  }

  /*
   * Random Shops
   */
  getRandomShops(params) {
    return http.get("/shop", { params });
  }

  /*
   * Recommended Shops
   */
  getRecommendedShops(params) {
    return http.get("/shop/recommended", { params });
  }

  /*
   * Add Shop
   */
  addShop(url) {
    return http.post("/shop", { url: url });
  }
}

export default new ShopService();
